import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import IServerOutput from 'features/server/model/Server/IServer';
import {IServerAlertRuleMetricOption} from 'features/server/model/ServerAlertRule/IServerAlertRuleRecommendations';

import ServerIncidentsFiltersForm from './ServerIncidentsFiltersForm';

interface IServerIncidentsFiltersModalProps {
    open: boolean;
    handleClose: () => void;
    servers: IServerOutput[];
    metricOptions: IServerAlertRuleMetricOption[];
}

const ServerIncidentsFiltersModal: React.FC<IServerIncidentsFiltersModalProps> = ({
    open,
    handleClose,
    servers,
    metricOptions,
}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose}>
        <ServerIncidentsFiltersForm servers={servers} metricOptions={metricOptions} onClose={handleClose}/>
    </FiltersModal>
);

export default ServerIncidentsFiltersModal;
